import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseClass } from '../../utility/baseClass';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { NgxSpinnerService } from 'ngx-spinner';
import { SubverticalService } from '../../main-layout/subvertical/subvertical.service';
import { Utilityservice } from '../../utility/utilityservice.service';

@Component({
  selector: 'app-subverticalmodal',
  templateUrl: './subverticalmodal.component.html',
  styleUrls: ['./subverticalmodal.component.css']
})
export class SubverticalmodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  saveTitle = 'Add'
  SubverticalForm: FormGroup;
  onlyView: any;
  isEdit: boolean = false;
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]
  existingdetails: any = {}
  verticalLabel: String = "";
  subverticalLabel: String = "";
  verticalList = [];
  validation_message: {
    verticalid: { type: string; message: string; }[];
    // 'subverticalname': [{ type: 'required', message: 'Enter Sub Vertical' }]
    subverticalname: { type: string; message: string; }[];
  };
  constructor(
    private subverticalService: SubverticalService,
    private fb: FormBuilder,
    public router: Router,
    public override  injector: Injector,
    public ref: DynamicDialogRef, private subverticalservice: SubverticalService,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice,
    private spinnerservice: NgxSpinnerService,
    private el: ElementRef
  ) {
    super(injector);
    this.gettoken();
    const dataFromParent = this.config.data;
    this.verticalLabel = dataFromParent.verticallabel;
    this.subverticalLabel = dataFromParent.subverticallabel;
    if (dataFromParent?.title == 'Modify Subvertical') {
      this.isEdit = true;
      this.saveTitle = 'Modify'
      this.existingdetails = dataFromParent.datas;
    }
  }

  ngOnInit() {
    this.get_dropdown();
    this.formInitiliaze();
    this.getData();
    this.validation_message = {
    'verticalid': [{ type: 'required', message: 'Select '+this.verticalLabel+' Name' }],
    // 'subverticalname': [{ type: 'required', message: 'Enter Sub Vertical' }]
    'subverticalname': [{ type: 'required', message: this.subverticalLabel+' Name is required' },
    { type: 'maxlength', message: 'Maximum length exceeded' },
    { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
    // { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
    { type: 'NOTALLOW_SPECIAL_CHAR', message: "Special character not allowed (% and ')" }
    ]
  }
  }

  get_dropdown() {
    this.subverticalService.get_vertical().subscribe(res => {
      this.verticalList = res;
    })
  }

  getData() {
    this.patchValueForms(this.existingdetails[0])
  }

  patchValueForms(data) {
    this.SubverticalForm.patchValue({
      'verticalid': data?.verticalid,
      'subverticalname': data?.subverticalname
    });
  }
  dismiss() {
    Swal.fire({
      title: "Are you sure you want to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }

  formInitiliaze() {
    this.SubverticalForm = this.fb.group({
      subverticalname: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(200),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)
      ])],
      verticalid: ['', Validators.compose([
        Validators.required
      ])]
    })
  }

  tempsubvertical: any;
  addSubvertical() {
    console.log(this.SubverticalForm, "form");
    console.log(this.SubverticalForm.invalid);

    if (this.SubverticalForm.invalid) {
      this.validateAllFormFields(this.SubverticalForm, this.el);
    }

    else if (this.saveTitle == 'Modify') {
      this.modifySubvertical(this.SubverticalForm.value)
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          const payload = { csrftoken: this.CSRFToken, verticalid: this.SubverticalForm.value.verticalid, subverticalname: this.SubverticalForm.value.subverticalname };
          this.spinnerservice.show()
          this.subverticalservice.postsubvertical(payload).subscribe((data) => {
            this.tempsubvertical = data;
            this.spinnerservice.hide();
            if (this.tempsubvertical.response == 'exists') {
              Swal.fire(this.subverticalLabel + " already exists!", "", "error").then(result => {
              });
            } else {
              this.spinnerservice.hide();
              Swal.fire(this.subverticalLabel + " added successfully!", "", "success").then(result => {
                this.ref.close()
              });
            }
          }, error => {
            this.spinnerservice.hide();
            if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
            Swal.fire("Error!", error.error.response, "error");
                  }
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });
    }
  }


  modifySubvertical(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          const payload = { csrftoken: this.CSRFToken, verticalid: this.SubverticalForm.value.verticalid, subverticalname: this.SubverticalForm.value.subverticalname, subverticalid: this.existingdetails[0].subverticalid };
          this.subverticalservice.modifysubvertical(payload).subscribe((data) => {
            this.tempsubvertical = data;
            this.spinnerservice.hide();
            this.tempsubvertical = data;
            if (this.tempsubvertical.response == 'exists') {
              Swal.fire(this.subverticalLabel + " already exists!", "", "error").then(result => {
              });
            } else {
              this.spinnerservice.hide();
              Swal.fire(this.subverticalLabel + " modified successfully!", "", "success").then(result => {
                this.ref.close()
              });
            }
          }, error => {
            this.spinnerservice.hide();
            if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
            Swal.fire("Error!", error.error.response, "error");
                  }
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }
}
